import {
  call
} from './bridge'

const startFlow = () => {
  call('sgj://app/webview/startFlow')
}

const endFlow = () => {
  call('sgj://app/webview/endFlow')
}

const closeFlow = () => {
  call('sgj://app/webview/closeFlow')
}

export default {
  startFlow,
  endFlow,
  closeFlow,
}


// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestFlow.js